<div class="panel" [class.panel-primary]="(!ondrag && kontakt.sortIndex === 0)"
  [class.panel-success]="(!ondrag && kontakt.sortIndex > 0)" [class.panel-danger]="ondrag">
  <div class="panel-heading">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="pull-left">
          <span>Kontakt {{(kontakt.sortIndex + 1)}} {{ kontakt.sortIndex === 0 ? "(Hauptkontakt)" : "" }}</span>
        </div>
        <div class="pull-right">
          <button userRoleNeeded_hidden="Kontakte_Schreiben" type="button" style="margin-right:5px !important;"
            class="btn btn-xs btn-warning" title="Bearbeiten" (click)="onClickEditKontakt()"><span
              class="glyphicon glyphicon-edit"></span></button>
          <button userRoleNeeded_hidden="Kontakte_Schreiben" type="button" style="margin-right:5px !important;"
            class="btn btn-xs btn-danger" title="Löschen" (click)="onClickRemoveKontakt()"><span
              class="glyphicon glyphicon-remove"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="panel-body" style="overflow-x:auto; white-space: nowrap;">
    <div class="row">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">Typ :</label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <span class="form-control-static">{{kontakt.kontaktType}}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">Name :</label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <span class="form-control-static">{{kontakt.name}}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">Vorname :</label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <span class="form-control-static">{{kontakt.vorname}}</span>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="kontakt.telefon1">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">Tel.Nr.1 :</label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <a class="form-control-static" [attr.href]="('tel:'+kontakt.telefon1)">{{kontakt.telefon1}}</a>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="kontakt.telefon2">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">Tel.Nr.2 :</label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <a class="form-control-static" [attr.href]="('tel:'+kontakt.telefon2)">{{kontakt.telefon2}}</a>

        </div>
      </div>
    </div>
    <div class="row" *ngIf="kontakt.fax">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">Fax :</label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <span class="form-control-static">{{kontakt.fax}}</span>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="kontakt.mail1">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">
            <cz-kontakt-email-button *ngIf="kontakt" [kontakt]="kontakt" (emailSendFinished)="onEmailSendFinished()"
              [emailAdress]="kontakt.mail1"></cz-kontakt-email-button> Mail 1 :
          </label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <span class="form-control-static">{{kontakt.mail1}}</span><br />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="kontakt.mail2">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">
            <cz-kontakt-email-button *ngIf="kontakt" [kontakt]="kontakt" (emailSendFinished)="onEmailSendFinished()"
              [emailAdress]="kontakt.mail2"></cz-kontakt-email-button> Mail 2 :
          </label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <span class="form-control-static">{{kontakt.mail2}}</span><br />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="kontakt.webAdresse">
      <div class="form-group-sm">
        <div class="col-md-4 col-sm-12 align-right">
          <label class="control-label">Web :</label>
        </div>
        <div class="col-md-8 col-sm-12 align-left">
          <a class="form-control-static" target="_blank"
            [attr.href]="('http://'+kontakt.webAdresse)">{{kontakt.webAdresse}}</a>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-footer">
    <div style="display: flex; flex-direction: column; width: 100%;">

      <div style="width: 100%; flex: 1 1 auto; display: flex; justify-content: space-between;">
        <span style="font-size: 9px">
          Geändert am:
        </span>

        <strong style="font-size: 9px; float: right;">
          {{changeDate}}
        </strong>
      </div>

      <div style="width: 100%; flex: 1 1 auto; display: flex; justify-content: space-between;">
        <span style="font-size: 9px">
          Von:
        </span>

        <strong style="font-size: 9px; float: right;">
          {{kontakt.aenderungsBenutzer}}
        </strong>
      </div>
    </div>

  </div>
</div>
